/* eslint-disable camelcase */
const getOrderFromReservationDetails = (
  details,
  // gratuity / service charge options
  serviceChargeOptions = []
) => {
  const amounts = details.payment?.amounts;

  if (!amounts) {
    return undefined;
  }

  return {
    items: amounts.items?.map?.(
      (item) => ({
        amount: item.amount,
        is_included: item.is_included,
        name: item.name,
        quantity: item.quantity,
      })
    ),
    quantity: amounts.quantity,
    reservationCharge: amounts.reservation_charge,
    serviceCharge: amounts.service_charge,
    serviceChargeOptions: serviceChargeOptions.map?.(
      (opt) => ({
        amount: opt.amounts?.service_charge.amount,
        addOns: opt.amounts?.add_ons,
        pricePerUnit: opt.amounts?.price_per_unit,
        tax: opt.amounts?.tax,
        total: opt.amounts?.total,
        value: opt.amounts?.service_charge.value,
      })
    ),
    serviceFee: amounts.service_fee,
    subtotal: amounts.subtotal,
    tax: amounts.tax,
    total: amounts.total,
  };
};

export default getOrderFromReservationDetails;
